import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

const FireflyEffect = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(window.innerWidth, window.innerHeight);
    if (mountRef.current) {
      mountRef.current.appendChild(renderer.domElement);
    }

    // Particle settings
    const particleCount = 500;
    const positions = [];
    const colors = [];
    const sizes = [];

    for (let i = 0; i < particleCount; i++) {
      positions.push(Math.random() * 800 - 400);
      positions.push(Math.random() * 800 - 400);
      positions.push(Math.random() * 800 - 400);

      colors.push(Math.random(), Math.random(), Math.random());
      sizes.push(2);
    }

    const particleGeometry = new THREE.BufferGeometry();
    particleGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    particleGeometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    particleGeometry.setAttribute('size', new THREE.Float32BufferAttribute(sizes, 1));

    const particleMaterial = new THREE.PointsMaterial({
      size: 5,
      vertexColors: true,
      transparent: true,
      opacity: 0.8,
      blending: THREE.AdditiveBlending,
    });

    const particleSystem = new THREE.Points(particleGeometry, particleMaterial);
    scene.add(particleSystem);

    camera.position.z = 500;

    const animate = () => {
      requestAnimationFrame(animate);

      particleSystem.rotation.x += 0.002;
      particleSystem.rotation.y += 0.002;

      const positionsArray = particleGeometry.attributes.position.array;
      for (let i = 1; i < positionsArray.length; i += 3) {
        positionsArray[i] += Math.random() * 0.01;
        if (positionsArray[i] > 400) positionsArray[i] = -400;
      }

      particleGeometry.attributes.position.needsUpdate = true;

      renderer.render(scene, camera);
    };

    animate();

    return () => {
      if (mountRef.current && renderer.domElement) {
        mountRef.current.removeChild(renderer.domElement);
      }
    };
  }, []);

  return <div ref={mountRef} className="firefly-container"></div>; // Apply the firefly-container class
};

export default FireflyEffect;
